import React, { useEffect, useRef, useState } from "react";
import { stats } from "../../mock";

function useCountUp(target, active) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    const num = parseFloat(target);
    if (isNaN(num)) return;
    const dur = 1400;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(num * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, active]);
  const isFloat = String(target).includes(".");
  return isFloat ? val.toFixed(1) : Math.round(val).toString();
}

function StatItem({ stat, active }) {
  const display = useCountUp(stat.value, active);
  return (
    <div className="text-center px-4">
      <div className="font-display text-4xl sm:text-5xl font-700 gold-text">
        {display}{stat.suffix}
      </div>
      <div className="mt-2 text-xs sm:text-sm uppercase tracking-widest text-white/60">{stat.label}</div>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver(([e]) => e.isIntersecting && setActive(true), { threshold: 0.4 });
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 divide-gold/20 lg:divide-x">
          {stats.map((s) => (
            <StatItem key={s.label} stat={s} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
}
